module.exports = __webpack_public_path__ + "PPicon.png?30f0b997c9ca1b198a174127687a57b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/PPicon.png
// module id = 45
// module chunks = 0